import * as Sentry from '@sentry/react'
import {
  dynamicSamplingContextToSentryBaggageHeader,
  generateSentryTraceHeader,
} from '@sentry/utils'

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const SENTRY_PUBLIC_KEY = SENTRY_DSN?.match(/https:\/\/(.*?)@/)?.[1] || ''

export const getSentryHeaders = () => {
  const span = Sentry.getActiveSpan()

  let sentryHeaders: Record<string, string> = {}

  if (span) {
    const ctx = span.spanContext()
    sentryHeaders = {
      'sentry-trace': generateSentryTraceHeader(
        ctx.traceId,
        ctx.spanId,
        ctx.traceFlags === 1
      ),
      baggage:
        dynamicSamplingContextToSentryBaggageHeader({
          trace_id: ctx.traceId,
          public_key: SENTRY_PUBLIC_KEY || '',
          environment: process.env.REACT_APP_SENTRY_ENV || 'production',
        }) || '',
    }
  }

  return sentryHeaders
}
